import React, { createContext, useContext, useState } from 'react';

const ShowLoginModalContext = createContext({});

export function ShowLoginModalProvider({ children }) {
    const [showLoginModal, setShowLoginModal] = useState(false);
    return (
        <ShowLoginModalContext.Provider value={{ showLoginModal, setShowLoginModal }}>
            {children}
        </ShowLoginModalContext.Provider>
    );
}

export function useShowLoginModal() {
    return useContext(ShowLoginModalContext);
}
